import React from 'react';
import c from 'classnames';
import { Block } from '@uncinc/react-drupal-core';


const ViewPluginEntity = ({ entity }) => {
  const id = entity.getIn(['id', 0, 'value']);
  const uuid = entity.getIn(['uuid', 0, 'value']);
  const langcode = entity.getIn(['langcode', 0, 'value']);

  return <Block id={id} key={`${uuid}:${langcode}`} entity={entity} />;
};

const ViewPluginText = ({ plugin }) => {
  // @TODO implement this...
  return JSON.stringify(plugin);
};

const ViewArea = ({ className, children }) => {
  if (!children || children.size < 1) {
    return null;
  }

  return (
    <div className={c('ViewArea', className)}>
      {children.map((plugin) => {
        const type = plugin.get('type');

        switch (type) {
          case 'entity': {
            return <ViewPluginEntity key={`viewArea-${type}`} entity={plugin.get('entity')} />;
          }

          case 'text': {
            return <ViewPluginText key={`viewArea-${type}`} plugin={plugin} />;
          }

          default: {
            return JSON.stringify(plugin);
          }
        }
      })}
    </div>
  );
};

export default ViewArea;
